import { browserHistory } from 'react-router';
import { message } from 'antd';
import localDb from '@util/localDb';

function isLogin() {
  return localDb.get('token');
}

/**
 * [interceptor Http请求拦截，如果无权限的情况，或者登陆失效的情况，跳转登录页。]
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
export default function interceptor(response) {
  // store.dispatch(setReqState('success'));
  if (response.status === 403) {
    message.warning('登录过期，请重新登录！');
    localDb.clear();
    browserHistory.replace(`/login`);
    return Promise.reject(response);
  }
  return response;
}

// 路由拦截
export function auth(next, replace) {
  const path = next.location.pathname;
  if (isLogin() || path.indexOf('login') > -1) {
    replace(null, path);
  } else {
    // message.warning("登录过期，请重新登录！")
    replace('/login');
  }
}



// WEBPACK FOOTER //
// ./src/util/interceptor.js